<ng-container *ngIf="vm$ | async as vm">
  <form class="zoek__form" name="frmNotitiesZoek" (ngSubmit)="searchCmdSubj.next(true)">

    <div class="zoekpanel__row">

      <h1 class="head1">Zoeken in notities</h1>

      <div class="zoekinput__row">
        <input class="zoekinput" aria-label="Geef zoektermen in" type="text" name="SearchFor" [(ngModel)]="vm.searchArg.SearchFor" />
        <button type="submit" class="btn btn-primary">zoeken <i class="icon-zoom"></i></button>
        <button (click)="navigateToZoekAgendapunten(vm.searchArg)" type="button" class="btn btn-primary">agendapunten<i
            class="icon-zoom"></i></button>
        <button (click)="navigateToZoekDocumentenZitting(vm.searchArg)" type="button" class="btn btn-primary">documenten
          zitting<i class="icon-zoom"></i></button>
      </div>

      <div class="zoekfilters__row">

        <select title="Filter eigen notities" [(ngModel)]="vm.searchArg.SoortNotities" (change)="searchCmdSubj.next(true)" name="SoortNotities">
          <option value="alle">Alle notities</option>
          <option value="eigen">Eigen notities</option>
        </select>

        <select title="Filter periode" [(ngModel)]="vm.searchArg.PeriodeFilter" (change)="searchCmdSubj.next(true)" name="SoortPeriode">
          <option value="null">Periode...</option>
          <option *ngFor="let periode of vm.periodes" [ngValue]="periode.value">{{periode.omschrijving}}</option>
        </select>

        <select title="Optie combineer zoektermen" name="andorfilter" [(ngModel)]="vm.searchArg.CombineWordsWith" (change)="searchCmdSubj.next(true)">
          <option value=" or ">Eén van de ...</option>
          <option value=" and ">Alle ...</option>
          <option value="exact">Exact</option>
        </select>

        <a href="#" role="button" (click)="resetFilter()" class="size1 c2-clickable">wissen</a>
      </div>

      <div class="zoekinput__row" *ngIf="vm.searchArg.PeriodeFilter=='C'">
        <label for="notitiezoeken_vanjaar">Van jaar</label>
        <input id="notitiezoeken_vanjaar" title="Van jaar" class="jaar" type="number" required name="vanJaar" [(ngModel)]="vm.searchArg.VanJaar" min="1970"
          max="2099">
        <label for="notitiezoeken_totjaar">Tot jaar (optioneel)</label>
        <input id="notitiezoeken_totjaar" class="jaar" type="number" name="totJaar" [(ngModel)]="vm.searchArg.TotJaar" min="" max="2099">
      </div>
    </div>
  </form>

  <span class="head3 geenresultaten" *ngIf="vm.notities.length==0">Geen resultaten</span>
  <app-notitie-list class="notitie__list" [notities]="vm.notities" [hasMoreResults]="vm.hasMoreResults"
    (getMoreResults)="searchMoreCmdSubj.next(true)"></app-notitie-list>

</ng-container>